import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { IonicPage, NavParams, ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController, AlertController } from 'ionic-angular';

import { TasksData } from '../../providers/tasks-data';
import { TasksEditPage } from './tasks-edit/tasks-edit';
import { UserData } from '../../providers/user-data';
import { MandantenData } from '../../providers/mandanten-data';
import { CommonData } from '../../providers/common-data';
import { Storage } from '@ionic/storage';
import { localeDe } from '../../providers/aggridlocale.de'


import { PbZonenactionsPage } from '../pbzonenactions/pbzonenactions';
import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';

/**
 * Generated class for the pbzonenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tasks',
  templateUrl: 'tasks.html',
})
export class TasksPage {
  @ViewChild('tasksGrid') agGrid: AgGridAngular;
  rowDataTasks:any;
  columnDefsTasks:any;
  gridOptionsTasks:any;
  searchQuery: string;
  bFilterActive: boolean;
  modules: Module[] = AllModules;
  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public taskData: TasksData
    , public userData: UserData
    , public mData: MandantenData
    , public popoverCtrl: PopoverController
    , public toastCtrl: ToastController
    , public common: CommonData
    , public storage: Storage
    , private alertCtrl: AlertController

  ) {
    this.bFilterActive = false;
    if(this.userData.usergroup_id == 1){
      this.columnDefsTasks = [
        {
          headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
        }

      ];      
      
    }
    else{
      this.columnDefsTasks = [];           
    }
    this.columnDefsTasks.push({headerName: 'Erledigt', field: 'done', resizable: true, width:100, valueGetter: this.doneTextValueGetter.bind(this)   });    

    this.columnDefsTasks.push({headerName: 'Topic', field: 'topic', resizable: true, width:150 });    
    
    this.columnDefsTasks.push({headerName: 'Name', field: 'name', resizable: true, width:200  });
    this.columnDefsTasks.push({headerName: 'Beschreibung', field: 'description', resizable: true, width:200 });
    this.columnDefsTasks.push({headerName: 'Kommentar', field: 'comment', resizable: true, width:200 });
    
    this.columnDefsTasks.push({headerName: 'Erzeugt', field: 'created', resizable: true, width:150,  type:['dateColumn', 'nonEditableColumn']  });
    
    this.gridOptionsTasks = {         
      localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,       
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      onGridReady: this.gridReady.bind(this),
      onFilterChanged: this.filterChanged.bind(this),
      
      floatingFilter: true,
      defaultColDef : {
        filter:true,
        sortable: true
      }
    }
  }

  gridReady(event){
    
    //this.loadFilters();
  }
  
  filterChanged(event){
    /*
    var model = this.agGrid.gridOptions.api.getFilterModel();
    this.storage.set("pbzonefilter", model);        

    if(Object.keys(model).length !== 0){
      this.bFilterActive = true;
    }
    else{
      this.bFilterActive = false;
    }
    */
  }
  ionViewWillEnter() {
    
    this.loaddata();
  }  

  async loadFilters(){
    /*
    let pbzonefilter = await this.storage.get("pbzonefilter");
    if(!pbzonefilter){
      pbzonefilter = {
        archiviert: {
          filterType: 'text',
          type: 'equals',
          filter: 'nein',
        }
      };
    }
    this.agGrid.api.setFilterModel(pbzonefilter);     
    var model = this.agGrid.api.getFilterModel();
    */
  }

  ionViewDidEnter(){
    
  }

  doneTextValueGetter = function (params){
    return this.common.boolToText(params.data.done);
  }

  firstDataRendered(event){
    this.defaultFilter();
  }
  defaultFilter(){


    var filterComponent = this.agGrid.api.getFilterInstance('done');
    //console.log(statusFilterComponent);
    var model = {
        type: 'set',
        values: ['nein']
    };

    filterComponent.setModel(model);
    this.agGrid.api.onFilterChanged();
  }

  loaddata() {
    this.common.showMessage('Daten werden geladen/aktualisiert', 2000);
    this.taskData.load().then(res => {      
      if(!this.rowDataTasks || this.rowDataTasks.lenght==0){
        this.rowDataTasks = this.taskData.data;
      }
      else{
        //-- Neue Eitnräge hinzufügen ------
        for(let i=0; i<this.taskData.added_ids.length; i++){

          let newData = this.taskData.data.find(x => x.id === this.taskData.added_ids[i]);
          if(newData){
            this.gridOptionsTasks.rowData.push(newData)
            this.agGrid.api.setRowData(this.gridOptionsTasks.rowData);
          }    
        }
        this.taskData.added_ids.length = 0;
        //-- Einzeleinträge aktualisieren ---
        //let rowsSelection = this.agGrid.api.getSelectedRows();
        let selectedNodes = this.agGrid.api.getSelectedNodes();
        //console.log(rowsSelection.length);
        for(let i=0; i<selectedNodes.length; i++){
          let actnode = selectedNodes[i];
          let newData = this.taskData.data.find(x => x.id === actnode.data.id);
          if(newData){
            actnode.setData(newData);
            this.agGrid.api.onFilterChanged();
          }    
        }

        this.agGrid.api.sizeColumnsToFit();
        
      }
      
    });    
    
  }   

  showDetail(detail){
    this.navCtrl.push(TasksEditPage, {id:detail.id});
  }
  add(){
    this.navCtrl.push(TasksEditPage, {id:-1});    
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node) {
    return true;
  }  

  filterItems(ev: any) {
    this.searchGrid(ev);

  }     
  searchGrid(event){
    this.agGrid.api.setQuickFilter(this.searchQuery);
  }  

  gridRowDblClicked(event: any){ 
    this.showDetail(event.data)
  }

  gridClearFilter(){

    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }    


}




// WEBPACK FOOTER //
// ./src/pages/tasks/tasks.ts